import type { UserApiResponse } from '@/domains/user/user.entity';
import type { UserRepository } from '@/domains/user/user.repository';

/**
 * Use Case para obtener todos los usuarios del sistema
 *
 * Responsabilidades:
 * - Obtener la lista completa de usuarios desde el repositorio
 * - Actuar como intermediario entre la capa de dominio y la infraestructura
 */
export class GetUsersUseCase {
  private repository: UserRepository;

  /**
   * Inicializa el UseCase con el repositorio necesario
   * @param repository - Repositorio para operaciones de usuarios
   */
  constructor(repository: UserRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta la obtención de todos los usuarios
   * @throws Error si falla la comunicación con el repositorio
   */
  async execute(): Promise<UserApiResponse> {
    return await this.repository.getUsers();
  }
}
